import {AxiosResponse} from "axios";

import ResourceApi from "@/src/modules/core/api/resource-api";

import type {DispatchLog} from "../types";

const PATH = "dispatchlog";

class DispatchLogsApi extends ResourceApi<DispatchLog> {
  constructor() {
    super(PATH);
  }

  getDispatchLogTypes(): Promise<
    AxiosResponse<{dispatch_log_types: {dispatch_log_type_id: number; type: string}[]}>
  > {
    return this.get("dispatchlogtype");
  }
}

export const dispatchLogsApi = new DispatchLogsApi();
